import { render, staticRenderFns } from "./contentDistributionArticle.vue?vue&type=template&id=34d2ae0e&scoped=true"
import script from "./contentDistributionArticle.vue?vue&type=script&lang=js"
export * from "./contentDistributionArticle.vue?vue&type=script&lang=js"
import style0 from "./contentDistributionArticle.vue?vue&type=style&index=0&id=34d2ae0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d2ae0e",
  null
  
)

export default component.exports